import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/schedules', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/schedules', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/schedules/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getWeekdays = (Options = {}) => {
  return httpClient
    .get('/api/schedules/weekdays')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getScheduleTypes = (Options = {}) => {
  return httpClient
    .get('/api/schedules/schedule-types')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getScheduleTime = (Options = {}) => {
  return httpClient
    .get('/api/schedules/schedule-times')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTimeList = (Options = {}) => {
  return httpClient
    .get('/api/schedules/schedule-times', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const updateClass = (id, data) => {
  return httpClient
    .put(`/api/schedules/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSubjects = (Options = {}) => {
  return httpClient
    .get('/api/schedules/subjects', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const previewSchedulePdf = data => {
  return httpClient
    .post('/api/schedules/pdf-previews', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  find,
  updateClass,
  getWeekdays,
  getScheduleTypes,
  getScheduleTime,
  getTimeList,
  getSubjects,
  previewSchedulePdf
}
